<template>
  <div class="systemPrompt">
    <h1 class="title">找回密码</h1>
    <div class="complete">
      <div>
        <!-- <p style="margin:0;">
          <img src="../../assets/complete2.png">
        </p> -->
        <p class="friendly-tips" style="margin-top:120px;">管理员帮你找回密码：</p>
        <!-- <p class="friendly-tips">当你忘记密码时，方便找回密码。</p> -->
        <p style="font-size:16px;color:#333333;margin-bottom:45px;">你可通过在本系统内发送短消息给管理员，由管理员核实身份后重置你的登录密码。</p>
      </div>
      <!-- <el-button type="info" plain>稍后修改密码</el-button> -->
      <el-button type="info" plain @click="restart">重新找回密码</el-button>
      <el-button type="primary" @click="sendMessage">给管理员发消息</el-button>
    </div>
    <el-dialog title="提示" :visible.sync="isForget" width="400px" >
      <div style="width: 100%;">
        <div style="text-align: center;margin-bottom: 20px;">
          <img src="../../assets/images/img_failedtoload.png">
        </div>
        <div style="text-align: center">
          <img src="../../assets/images/img_prompt.png">
          <span style="position: relative;top: -5px;left: 3px;">请与培训中心管理员联系</span>
          <p style="text-align:center">
            <el-button type="primary" @click="isForget=false">我知道了</el-button>
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isForget: false
    }
  },
  created () {
    if (sessionStorage.step === '') {
      this.$router.push('/')
    }
  },
  mounted () {
  },
  methods: {
    sendMessage () {
      this.isForget = true
    },
    restart () {
      this.$router.push('/FindPass/CheckIdInfo')
    }
  }
}
</script>
<style lang="scss">
.systemPrompt {
  width: 1020px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  .title {
    font-weight: normal;
    font-size: 24px;
    margin: 30px 40px;
    color: #333333;
    border-bottom:1px solid #eeeeee;
    padding-bottom: 20px;
  }
  .complete {
    text-align: center;
    img {
      margin: 50px 0 30px 0;
    }

    .el-button + .el-button {
      margin-left: 20px;
      background-color: #1060ab;
    }

    .friendly-tips {
      margin-left: 10px;
      font-size: 24px;
      margin: 0;
      margin-bottom: 20px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/findPass/contactAdmin.vue